module.exports = __webpack_public_path__ + "static/img/11areaA_12.ac8b950.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/11areaA_12.png
// module id = 996
// module chunks = 1